var tablist = {};

(function ($) {

  tablist.init = function () {

    tablist.linksTouch();
  };

  tablist.linksTouch = function () {
    $('.js-carousel-link').flickity({
      // options
      cellAlign: 'center',
      contain: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false
    });
  };


  $(document).ready(function () {
    tablist.init();
  });

})(jQuery);
